import * as React from 'react';
import { Link } from 'react-router-dom';
import { ToolState, GraphFilters, FundTypes } from '../models';
import Graph from './Graph/Graph';
import Controls from './Controls/Controls';
import Results from './Results/Results';
import logo from '../assets/images/stackr-icon.svg';
import { Help } from '../assets/icons';
import Footer from './Footer/Footer';
import SecondaryFooter from './SecondaryFooter/SecondaryFooter';

interface ToolProps extends ToolState {
  updateFundFilter: (x: GraphFilters) => object;
  setDigitalFund: (x: FundTypes) => object;
  setCapitalFund: (x: FundTypes) => object;
  setAllocation: (x: number) => object;
  setDuration: (x: number) => object;
  setLumpSum: (x: number) => object;
  setMonthlyContribution: (x: number) => object;
}

const Tool = (props: ToolProps) => (
  <div className='tool-wrap'>
    <div className='header'>
      <a href='https://www.gostackr.com'>
        <img src={logo} className='header-logo' />
      </a>
      <Link to={{ pathname: '/walkthrough' }} className='walkthrough-link'>
        Help
        <Help />
      </Link>
    </div>
    <div className='graph-wrap'>
      <Results
        high={props.highCaseOutcome}
        low={props.lowCaseOutcome}
        medium={props.mediumCaseOutcome}
      />
      <Graph data={props.graphData} />
    </div>
    <Controls
      digitalFundSelected={props.digitalFund}
      capitalFundSelected={props.capitalFund}
      setCapitalFund={props.setCapitalFund}
      setDigitalFund={props.setDigitalFund}
      allocation={props.allocation}
      setAllocation={props.setAllocation}
      duration={props.duration}
      setDuration={props.setDuration}
      lumpSum={props.lumpSum}
      monthlyContribution={props.monthlyContribution}
      setLumpSum={props.setLumpSum}
      setMonthlyContribution={props.setMonthlyContribution}
    />
    <Footer />
    <SecondaryFooter />
  </div>
);

export default Tool;
